<template>
  <div class="ms-form ms-form--narrow">
    <q-form @submit="this.onSubmit">
      <q-input
        v-model="this.searchQuery"
        outlined
        dense
        placeholder="Поиск..."
        clearable
        autofocus
        class="search-input"
      >
        <template v-slot:prepend>
          <q-icon name="search" size="18px" />
        </template>
      </q-input>

      <div class="list-wrap" v-if="!this.isFetching">
        <div
          v-for="item in this.filteredListData"
          :key="item[this.valueKey]"
          :class="['list-item', { 'list-item--selected': item[this.valueKey] === this.value }]"
          @click="this.onChange(item[this.valueKey])"
        >
          {{ item[this.labelKey] }}
          <q-icon v-if="item[this.valueKey] === this.value" name="check" size="16px" class="check-icon" />
        </div>
        <div v-if="this.filteredListData.length === 0" class="list-empty">
          Не найдено
        </div>
      </div>
      <div v-else class="list-wrap list-wrap--loading">
        <q-spinner size="24px" color="primary" />
      </div>

      <div class="fortItem">
        <CustomInput
            v-if="this.agreementSum !== undefined"
            type="number" label="Введите сумму спецификации (для автоматического рассчета оставить пустым):"
            :showClearIcon="false"
            :value="this.agreementSum"
            @change_input="this.onSumChange"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" :disable-submit="this.isFetching || !this.value"/>
    </q-form>
  </div>
</template>

<script>
import {
  getRemontResponsibleData,
  getResponsibleAgreementSum,
  updateRemontResponsibleData
} from "@/components/modal/modals/change-remont-responsible/services";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import {appActions} from "@/services/store/modules/app_module/app_actions";
import CustomInput from "@/components/form/CustomInput";

export default {
  name: "ChangeRemontResponsible",
  components: {CustomInput, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      listData: [],
      value: this.data?.id || '',
      label: 'Выберите',
      isFetching: false,
      agreementSum: undefined,
      loading: false,
      labelKey: '',
      valueKey: '',
      searchQuery: '',
    }
  },
  computed: {
    filteredListData() {
      if (!this.searchQuery) return this.listData
      const q = this.searchQuery.toLowerCase()
      return this.listData.filter(item => {
        const label = item[this.labelKey]
        return typeof label === 'string' && label.toLowerCase().includes(q)
      })
    },
  },
  methods: {
    onChange(value) {
      this.value = value
    },
    onSumChange(value) {
      if(Number(value) < 0 || !value)
        return this.agreementSum = 0
      this.agreementSum = value
    },
    async getData() {
      this.isFetching = true
      const res = await getRemontResponsibleData(this.data?.valueCode)
      if (this.isRequireToFetchAgreementSum())
        await this.getAgreementSum()
      this.isFetching = false
      if (!res) return
      const {data, label, labelKey, valueKey} = res
      this.listData = data
      this.label = label
      this.labelKey = labelKey
      this.valueKey = valueKey
    },
    async getAgreementSum() {
      const res = await getResponsibleAgreementSum(this.data?.client_request_id, this.data?.valueCode)
      if (res === undefined) return
      this.agreementSum = res
    },
    isRequireToFetchAgreementSum() {
      const valueCode = this.data?.valueCode
      return valueCode === 'contractor_id' ||
          valueCode === 'general_contractor_id' ||
          valueCode === 'techproject_developer_id' ||
          valueCode === 'support_manager_id'
    },
    async onSubmit() {
      if (!this.data?.onSubmit) return
      const body = {[this.data?.valueCode]: this.value}

      if (this.isRequireToFetchAgreementSum())
        body.agreement_sum = Number(this.agreementSum || 0)
      this.loading = true
      const res = await updateRemontResponsibleData(this.data?.client_request_id, this.data?.valueCode, body)
      this.loading = false
      if (!res) return
      this.data?.onSubmit(res)
      this.$store.commit(appActions.closeModal());
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="scss">
// ширина — общая (ms-form в theme.scss)
.search-input {
  margin-bottom: 8px;
}

.list-wrap {
  border: 1px solid var(--ms-border-input);
  border-radius: var(--ms-radius-sm);
  max-height: 320px;
  overflow-y: auto;

  &--loading {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100px;
  }
}

.list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
  border-bottom: 1px solid var(--ms-divider);
  transition: background-color 0.15s;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: var(--ms-row-hover);
  }

  &--selected {
    background-color: var(--ms-primary-50);
    color: var(--ms-primary);
    font-weight: 500;
  }
}

.check-icon {
  color: var(--ms-primary);
  flex-shrink: 0;
}

.list-empty {
  padding: 16px 12px;
  font-size: 13px;
  color: var(--ms-muted);
  text-align: center;
}

.fortItem {
  margin-top: 14px;
}
</style>
